import * as React from 'react';
import { cn } from '@/lib/utils';

export interface WfEmptyProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Ícone opcional (renderizado acima do texto, opacity .5 — wireframe .chan-empty .ic). */
  icon?: React.ReactNode;
}

/** Empty state do wireframe (.chan-empty). */
export const WfEmpty = React.forwardRef<HTMLDivElement, WfEmptyProps>(
  ({ icon, className, children, ...props }, ref) => (
    <div ref={ref} className={cn('wf-empty', className)} {...props}>
      {icon && <div>{icon}</div>}
      <div>{children}</div>
    </div>
  )
);
WfEmpty.displayName = 'WfEmpty';
